/* The sign-in panel's buttons, shared by the sign-in page and the hand-off's continue page. */
/** Mantine resolves variant colors to inline variables, so the page's tokens are handed over the same way. */
const buttonVars = (bg: string, hover: string, color: string, border: string) => () => ({
  root: {
    "--button-bg": bg,
    "--button-hover": hover,
    "--button-color": color,
    "--button-bd": border,
    "--button-radius": "0.5rem",
    "--button-height": "2.625rem",
    "--button-fz": "0.875rem",
  },
});
export const primaryVars = buttonVars("var(--si-fg)", "hsl(0 0% 88%)", "hsl(0 0% 9%)", "0");
export const secondaryVars = buttonVars(
  "transparent",
  "hsl(0 0% 100% / 0.05)",
  "var(--si-fg)",
  "1px solid var(--si-ring)",
);
